import { render, staticRenderFns } from "./FrameworkSequenceDetailEdit.vue?vue&type=template&id=820f1be8"
import script from "./FrameworkSequenceDetailEdit.vue?vue&type=script&lang=js"
export * from "./FrameworkSequenceDetailEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports